webpackJsonp([35],{

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module('appMarketplace')
    .controller('LegacyPageCtrl', ['$scope', 'UrlService', function ($scope, UrlService) {
        $scope.logoutUrl = UrlService.createAbsoluteUrl('/useradmin/logout.jsp');
    }]);

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(236);
angular.element(function() {
    angular.bootstrap(document, ['appMarketplace']);
});

/***/ })

},[498]);


// WEBPACK FOOTER //
// legacyPageEntry.js?ver=2d5f454c93e30b24a70e